// Hook that provides table display styles
export const useDisplayTableStyles = () => {
  return {
    root: {
      flexGrow: 1,
      overflowX: "auto",
      marginTop: 2,
      marginBottom: 2,
    },
    table: {
      minWidth: 700,
    },
    tableFooter: {
      height: "60px",
    },
  };
};

// For backward compatibility
const displayTableStyles = useDisplayTableStyles;
export default displayTableStyles;
